import { Caption, HeadingH1, HeadingH2, HeadingH3, HeadingH4, HeadingH5, HeadingH6, Paragraph, Subtitle } from "./Style";
import { style } from "./StyleType";

interface TmpTypographyCustomProps {
    id: string;
    component: "heading" | "subtitle" | "caption" | "paragraph";
    variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
    size?: "small" | "medium" | "large" | "display";
    children: React.ReactNode;
}


export default function TmpTypographyCustom(props: TmpTypographyCustomProps) {

    // Passing style props to styled component
    HeadingH1.defaultProps = style;
    HeadingH2.defaultProps = style;
    HeadingH3.defaultProps = style;
    HeadingH4.defaultProps = style;
    HeadingH5.defaultProps = style;
    HeadingH6.defaultProps = style;
    Subtitle.defaultProps = style;
    Paragraph.defaultProps = style;
    Caption.defaultProps = style;


    const createHeading = () => {

        const patternSize = props.size !== undefined ? props.size : "medium";
        const patternVariant = props.variant !== undefined ? props.variant : "h1";

        switch (patternVariant) {
            case "h1":
                return (
                    <HeadingH1
                        id={props.id}
                        className={`tmp-typography tmp-typography__heading--${patternSize}`}
                        size={patternSize}
                    >
                        {props.children}
                    </HeadingH1>
                );
            case "h2":
                return (
                    <HeadingH2
                        id={props.id}
                        className={`tmp-typography tmp-typography__heading--${patternSize}`}
                        size={patternSize}
                    >
                        {props.children}
                    </HeadingH2>
                );
            case "h3":
                return (
                    <HeadingH3
                        id={props.id}
                        className={`tmp-typography tmp-typography__heading--${patternSize}`}
                        size={patternSize}
                    >
                        {props.children}
                    </HeadingH3>
                );
            case "h4":
                return (
                    <HeadingH4
                        id={props.id}
                        className={`tmp-typography tmp-typography__heading--${patternSize}`}
                        size={patternSize}
                    >
                        {props.children}
                    </HeadingH4>
                );
            case "h5":
                return (
                    <HeadingH5
                        id={props.id}
                        className={`tmp-typography tmp-typography__heading--${patternSize}`}
                        size={patternSize}
                    >
                        {props.children}
                    </HeadingH5>
                );
            case "h6":
                return (
                    <HeadingH6
                        id={props.id}
                        className={`tmp-typography tmp-typography__heading--${patternSize}`}
                        size={patternSize}
                    >
                        {props.children}
                    </HeadingH6>
                );
        }
    };

    const createSubtitle = () => {
        return (
            <Subtitle id={props.id} className="tmp-typography tmp-typography__subtitle">
                {props.children}
            </Subtitle>
        );
    };

    const createParagraph = () => {
        const patternSize = props.size !== undefined ? props.size : "medium";

        return (
            <Paragraph
                id={props.id}
                className={`tmp-typography tmp-typography__paragraph--${patternSize}`}
                size={patternSize}
            >
                {props.children}
            </Paragraph>
        );
    };

    const createCaption = () => {
        return (
            <Caption id={props.id} className="tmp-typography tmp-typography__caption">
                {props.children}
            </Caption>
        );
    };

    let template;

    switch (props.component) {
        case "heading":
            template = createHeading();
            break;
        case "subtitle":
            template = createSubtitle();
            break;
        case "caption":
            template = createCaption();
            break;
        case "paragraph":
            template = createParagraph();
            break;
        default:
            template = createHeading();
    }

    return template;
}